// extracted by mini-css-extract-plugin
export var container = "_5k-0";
export var fallback = "_5k-5";
export var fallbackIcon = "_5k-6";
export var hidden = "_5k-2";
export var image = "_5k-3";
export var loaded = "_5k-4";
export var placeholder = "_5k-1";